import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { getOrderIcon } from "../../../../Common/utils";
import { Order, toggleOrder } from "../../../../../utils/order";

function NameHeader({ onSort = () => {}, clearSort }) {
  const [order, setOrder] = useState(Order.asc);

  useEffect(() => {
    if (clearSort) setOrder("");
  }, [clearSort]);

  return (
    <div
      role="button"
      className="flex flex-row items-center"
      id="archive-student-list-sort-by-name-button"
      onClick={() => {
        const newOrder = toggleOrder(order);
        setOrder(newOrder);
        onSort(newOrder);
      }}
    >
      <span className="text-sm">List Name</span>
      {getOrderIcon(order)}
    </div>
  );
}

NameHeader.propTypes = {
  onSort: PropTypes.func,
  clearSort: PropTypes.bool
};

export default NameHeader;
